import { useState } from "react";
import isEmail from "validator/lib/isEmail";
import { Formik } from "formik";
import { FormattedMessage, injectIntl } from "react-intl";
import { intlShape, usersShape } from "../../shapes";
import UserItem from "./UserItem";
import ConfirmationModal from "../ConfirmationModal";

import { Button, Form, SubmitButton, TextInput } from "../Form";

import { isArray, isEmpty, isSomething } from "../../utils";
import { apiShape, notifierShape, withApi, withNotifier } from "../../context";
import { NotFoundError } from "../../api";

type OwnProps = {
  api?: apiShape;
  notifier?: notifierShape;
  intl: intlShape;
  users?: usersShape;
  canUpdate?: boolean;
  onAssignUser?: $TSFixMeFunction;
  onUnassignUser?: $TSFixMeFunction;
  disableUnassignForLastUser?: boolean;
  showUserEmail?: boolean;
  acceptConnectUsers?: boolean;
};

const defaultProps: Partial<OwnProps> = {
  acceptConnectUsers: false,
};

type Props = OwnProps & typeof defaultProps;

function AssignableUserList({
  api,
  intl,
  users,
  notifier,
  canUpdate,
  onAssignUser,
  showUserEmail,
  onUnassignUser,
  acceptConnectUsers,
  disableUnassignForLastUser,
}: Props) {
  const [userToUnassign, setUserToUnassign] = useState();

  const validConnectUser = (email: $TSFixMe) => {
    if (!acceptConnectUsers) {
      return false;
    }

    const regex = /@connect$/;
    return regex.test(email);
  };

  const validateEmail = (values: $TSFixMe) => {
    const errors = {};
    if (isEmpty(values.email)) {
      (errors as $TSFixMe).email = intl.formatMessage({
        id: "validation.email.mandatory",
      });
    } else if (!isEmail(values.email) && !validConnectUser(values.email)) {
      (errors as $TSFixMe).email = intl.formatMessage({
        id: "validation.email.invalid",
      });
    }
    return errors;
  };

  const assignUser = (values: $TSFixMe, actions: $TSFixMe) => {
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    api
      .get("/users/lookup", { email: values.email })
      .then((user: $TSFixMe) => {
        // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
        onAssignUser(user)
          .then(() => {
            // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
            notifier.showSuccess(
              intl.formatMessage({ id: "user_list.assign.notification" }),
            );
            actions.resetForm({ values: {} });
          })
          .catch((e: $TSFixMe) => {
            if (
              e.errors?.find(
                (error: $TSFixMe) =>
                  error.type === "associations_already_added",
              ) ||
              (isArray(e) &&
                e.find(
                  (error: $TSFixMe) =>
                    error.type === "associations_already_added",
                ))
            ) {
              // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
              notifier.showError(
                intl.formatMessage({
                  id: "user_group_details.error.already_assigned",
                }),
              );
            } else {
              // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
              notifier.showError(api.translateError(e));
            }
          });
      })
      .catch((error: $TSFixMe) => {
        if (error instanceof NotFoundError) {
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          notifier.showError(
            intl.formatMessage({
              id: "api.error.email.not_found_no_permission",
            }),
          );
        } else {
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          notifier.showError(api.translateError(error));
        }
      })
      .finally(() => actions.setSubmitting(false));
  };

  const doUnassignUser = () => {
    // @ts-expect-error TS(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
    setUserToUnassign(null);
    // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    onUnassignUser(userToUnassign)
      .then(() => {
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        notifier.showSuccess(
          intl.formatMessage({ id: "user_list.unassign.notification" }),
        );
      })
      .catch((errors: $TSFixMe) => {
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        notifier.showError(api.translateError(errors));
      });
  };

  const renderForm = (myProps: $TSFixMe) => {
    const { isSubmitting, values, errors } = myProps;
    return (
      <Form {...myProps}>
        <TextInput
          {...myProps}
          id="user-email"
          name="email"
          label={intl.formatMessage({ id: "label.email" })}
          hideLabel
        />
        <div className="btn-group">
          <SubmitButton
            id="assign-user-button"
            fetching={isSubmitting}
            disabled={!(!errors.email && !isEmpty(values.email))}
            text={intl.formatMessage({ id: "button.assign" })}
          />
        </div>
      </Form>
    );
  };

  const userItems = users
    ? users.map((user: $TSFixMe) => {
        const deleteButton = canUpdate ? (
          <Button
            text={intl.formatMessage({ id: "user_list.unassign" })}
            mobileIcon="icon-eh-unlink"
            onClick={() => setUserToUnassign(user)}
            disabled={users.length === 1 && disableUnassignForLastUser}
          />
        ) : null;
        return (
          <UserItem
            key={user.id}
            user={user}
            actions={deleteButton}
            showUserEmail={showUserEmail}
          />
        );
      })
    : null;

  return users ? (
    <div>
      {canUpdate && (
        <Formik
          onSubmit={(values, actions) => assignUser(values, actions)}
          validate={(values) => validateEmail(values)}
          initialValues={{}}
        >
          {renderForm}
        </Formik>
      )}
      {users.length > 0 ? (
        <ul className="list">{userItems}</ul>
      ) : (
        <FormattedMessage id="user_list.no_users_assign" />
      )}
      {canUpdate ? (
        <ConfirmationModal
          id="delete-modal"
          show={isSomething(userToUnassign)}
          titleText={intl.formatMessage({
            id: "user_list.unassign.confirmation.title",
          })}
          messageText={intl.formatMessage({
            id: "user_list.unassign.confirmation.message",
          })}
          onConfirm={() => doUnassignUser()}
          // @ts-expect-error TS(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
          onClose={() => setUserToUnassign(null)}
        />
      ) : null}
    </div>
  ) : null;
}

AssignableUserList.defaultProps = defaultProps;

// @ts-expect-error TS(2345) FIXME: Argument of type 'typeof AssignableUserList' is no... Remove this comment to see the full error message
export default injectIntl(withApi(withNotifier(AssignableUserList)));
